/*
 * Answers often write <br> for a line break inside a table cell, where
 * Markdown has no other way to break a line. Raw HTML is not rendered, so the
 * tag would show as text; this turns exactly that tag into a Markdown break.
 */
type MarkdownNode = { type: string; value?: string; children?: MarkdownNode[] };

const BREAK_TAG = /^<br\s*\/?>$/iu;

function replaceBreakTags(node: MarkdownNode) {
  if (!node.children) return;
  node.children = node.children.map((child) =>
    child.type === "html" && BREAK_TAG.test(child.value?.trim() ?? "") ? { type: "break" } : child);
  for (const child of node.children) replaceBreakTags(child);
}

export function remarkBreakTags() {
  return (tree: MarkdownNode) => replaceBreakTags(tree);
}
